import type { ReactElement, ReactNode } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { useViewport } from '@/lib/hooks/use-viewport';
import { BottomNav } from '@/components/organisms/bottom-nav';
import { TabletRail } from '@/components/organisms/tablet-rail';
import { DesktopSideNav } from '@/components/organisms/desktop-side-nav';

export type AppShellProps = {
  children: ReactNode;
};

export function AppShell({ children }: AppShellProps): ReactElement {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const viewport = useViewport();
  const bare = pathname === '/login';

  if (bare) {
    return <>{children}</>;
  }

  if (viewport === 'mobile') {
    return (
      <div className="min-h-screen flex flex-col">
        <div className="flex-1 pb-16">{children}</div>
        <BottomNav />
      </div>
    );
  }

  if (viewport === 'tablet') {
    return (
      <div className="min-h-screen flex">
        <TabletRail />
        <div className="flex-1 min-w-0">{children}</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex">
      <DesktopSideNav />
      <div className="flex-1 min-w-0">{children}</div>
    </div>
  );
}
